import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import { loginApiUrl, clientId, redirectUri} from '../../actions/config'
import {mapDispatchToProps} from "../mapDispatchToProps"
import ButtonLoading from "../common/ButtonLoading"
import CodeVerifierHelper from '../../util/code-verifier-helper';
import BuildParamsHelpers from '../../util/build-params-helper'

function LoginBlock(props) {
  const { isProcessing } = props;
  return (
    <div className="text-center login-block">
      <p className="line1">{i18n.t('login.login_block.line1')}</p>
      <p className="line2">{i18n.t('login.login_block.line2')}<br />
        {i18n.t('login.login_block.line3')}</p>
      <ButtonLoading text={i18n.t('login.login_block.login')} className="btn mfc-btn-blue medium" type="button" isProcessing={isProcessing} onClick={props.login} />
    </div>
  );
}

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isProcessing: false,
    };
  }

  async login() {
    this.setState(prevState => ({
      isProcessing: !prevState.isProcessing
    }));

    const params = await this.buildLoginParams()
    window.location.href = `${loginApiUrl}oauth/authorize?` + params
  }

  async buildLoginParams() {
    const codeChallenge =  await this.buildCodeChallenge()

    const params = {
      client_id: clientId,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      response_type: 'code',
      prompt: 'login',
      scope: 'openid%20email',
      redirect_uri: encodeURIComponent(redirectUri)
    }

    return BuildParamsHelpers.buildGetParams(params)
  }

  async buildCodeChallenge() {
    const verifier = CodeVerifierHelper.generateRandomString()
    window.sessionStorage.setItem("code_verifier", verifier)
    return await CodeVerifierHelper.challengeFromVerifier(verifier)
  }

  render() {
    const { isProcessing } = this.state;

    return (
      <div className="login-container">
        {this.props.isFetchingSession ? <span>Please wait a moment</span> :
          <LoginBlock login={() => this.login()} isProcessing={isProcessing} />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    code: state.session.get('code'),
    isFetchingSession: state.session.get('isFetchingSession')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
